import Vue from 'vue';
import Vuex from 'vuex';

import bgLayer from './modules/bgLayer';
import books from './modules/books';
import bookdetail from './modules/bookdetail';
import bookReviews from './modules/bookReviews';
import bookPayment from './modules/bookpayment';
import premiumPayment from './modules/premiumpayment';
import sendLog from './modules/sendLog';
import categories from './modules/categories';
import settings from './modules/settings';
import credits from './modules/credits';
import unlimited from './modules/unlimited';
import priceList from './modules/priceList'
import lightBox from './condition/lightbox';
import pageInformation from './condition/pageInformation';
import auth from './auth';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    bgLayer,
    lightBox,
    pageInformation,
    categories,
    auth,
    books,
    bookdetail,
    bookReviews,
    bookPayment,
    premiumPayment,
    sendLog,
    settings,
    credits,
    unlimited,
    priceList
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js